export const PlayerKey = {
  top: "top",
  bottom: "bottom",
  none: "none",
};

export const aspectColors = {
  villain: "#111",
  heroism: "#f2f2f2",
  vigilance: "#2298D2",
  aggression: "#C31924",
  cunning: "#F0BA32",
  command: "#00A44D",
  neutral: "#CCCCCC",
};
